import { Injectable } from '@angular/core';
import { BaseAPI } from '@core/services/base-api.service';
import { Mapper } from '@core/services/base-mapper.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { APIConstants } from '@shared/constants';
import { Announcement } from '@shared/models/announcement.model';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementApiService {

  constructor(
    private baseAPI: BaseAPI,
    private mapper: Mapper,
  ) { }

  getAnnouncement(): Observable<Announcement> {
    return this.baseAPI.get(APIConstants.GET_ANNOUNCEMENT).pipe(
      map((res) => {
        return this.mapper.fromJson(Announcement, res.data);
      })
    );
  }
}
